export default {
    subscriptionRequiredMessage:"Un abonnement actif est requis pour accéder à ce contenu",
    subscriptionPlansTitle:"Formules d'abonnement",
    subscriptionPlansDescription:"Choisissez la formule idéale pour votre parcours d'apprentissage des langues",
    subscriptionLabel:"Abonnements",
    currentSubscriptionPlanLabel:"Formule actuelle",
    popularPlanLabel:"Populaire",

    subscriptionPromptTitle: "Passez à la version Premium",
    subscriptionPromptDescription: "Choisissez une formule pour continuer votre préparation",
    subscriptionDaysLabel: "{{dayCount}} jours",
    subscriptionPaymentTypeLabel: "paiement unique",
    subscriptionFreeTrialLabel: "Essai gratuit",
    subscriptionFreeTrialActionLabel: "Commencer gratuitement",
    subscriptionPromptPositiveActionLabel: "Choisir l'offre {{subscriptionPlan}}",
    subscriptionPromptNegativeActionLabel: "Plus tard",
    subscriptionPromptFooterNote: "Paiement unique, sans renouvellement automatique."
}
